import { BaseClient } from 'src/common-services/clients/base-client'
import { SignUpRequest, SignUpResponse } from 'src/common-services/types/mobile-types'

export class MobileClient extends BaseClient {
  constructor() {
    // TODO(bmc): no device id for mobile?
    super({ deviceId: '' })
  }

  async signUp(request: SignUpRequest): Promise<SignUpResponse> {
    return this.post('/mobile/sign-up', request)
  }

  async accountConfirmation(token: string, email: string): Promise<SignUpResponse> {
    return this.call(`/mobile/account-confirmation/${token}`, 'PUT', { data: { email } })
  }
}
